// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages90_root__2RNIo","title":"AfterImages90_title__vnm3z","images":"AfterImages90_images__IBw6C"};